<lib-dialog [title]="title" [hasCloseButton]="hasDismissButton" (close)="activeModal.dismiss()">
	<div class="modal-body w-100">
		<div *ngTemplateOutlet="bodyTemplate"></div>
		{{ body }}
	</div>
	<div class="modal-footer w-100">
		<div *ngTemplateOutlet="footerTemplate"></div>
		{{ footer }}
	</div>
</lib-dialog>
